import DashboardHistory from './DashboardHistory';

export default DashboardHistory;
